module.exports = __webpack_public_path__ + "img/1.c5a9aee6.jpg";